import { NgModule } from '@angular/core';
import { HistoryOutletDirective } from './history-outlet/history-outlet.directive';

@NgModule({
  imports: [
  ],
  declarations: [
    HistoryOutletDirective
  ],
  exports: [
    HistoryOutletDirective
  ]
})
export class RouteHistoryModule { }



// WEBPACK FOOTER //
// ./src/app/pillar/layout/route-history.module.ts